export default __webpack_public_path__ + "static/media/location_red.afe1b912.svg";